import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import ContentGrid from "./components/ContentGrid";
import SEOArticlesSection from "./components/SEOArticlesSection";
import CTASection from "./components/CTASection";
import Testimonials from "./components/Testimonials";

const homepageSiteUrl = typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL
  ? import.meta.env.VITE_SITE_URL
  : "https://oopbuyspreadsheet.ink";

const homepageJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "OOPBuy Spreadsheet Guide & Product Lists",
    url: homepageSiteUrl + "/",
    description:
      "OOPBuy Spreadsheet is your ultimate product comparison hub. Explore curated buying guides, spreadsheet tools, product category lists, and expert sourcing strategies to make smarter purchase decisions.",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: homepageSiteUrl + "/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "OOPBuy Spreadsheet",
    url: homepageSiteUrl + "/",
    description:
      "Comprehensive product comparison hub with curated buying guides and spreadsheet-based sourcing tools for Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more.",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: homepageSiteUrl + "/",
      },
    ],
  },
];

export default function Home() {
  usePageMeta({
    title: "OOPBuy Spreadsheet Guide & Product Lists | Smart Sourcing Tools",
    description:
      "OOPBuy Spreadsheet is your ultimate product comparison hub. Explore curated buying guides, spreadsheet tools, product category lists, and expert sourcing strategies to make smarter purchase decisions.",
    keywords:
      "oopbuy spreadsheet, oopbuy guide, oopbuy products, spreadsheet product comparison, buying spreadsheet system, oopbuy product lists",
    canonicalPath: "/",
    jsonLd: homepageJsonLd,
  });

  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <ContentGrid />
      <SEOArticlesSection />
      <CTASection />
      <Testimonials />
      <Footer />
    </main>
  );
}